<template>

    <div class="col-md-12">
        <div class="card-header"><h1> Create User </h1></div>
        <form @submit.prevent="addUser">
            <div class="col-md-4">
                <div class="container-fluid bg-light py-3">
                    <div class="form-group">
                        <label>
                            <b> {{ JSON.parse(client).name }} </b>
                        </label>
                    </div>

                </div>
            </div>

            <div class="card">
                <div class="card-header"> General information</div>
                <div class="card-body">
                    <div class="container-fluid bg-light py-3">
                        <div class="row">
                            <div class="col-sm-4">

                                <div v-for="(errorArray, idx) in errors" :key="idx">
                                    <div v-for="(allErrors, idx) in errorArray" :key="idx">
                                        <span class="text-danger">{{ allErrors}} </span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <input type="text"  autocomplete="none" required class="form-control" placeholder="User name"
                                           v-model="user.name">
                                </div>

                                <div class="form-group">
                                    <input type="text" autocomplete="none" required class="form-control" placeholder="email"
                                           v-model="user.email">
                                </div>

                                <div class="form-group">
                                    <input type="password" required class="form-control" placeholder="password"
                                           v-model="user.password">
                                </div>

                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>
        <a href="/clients" title="Back">
            <button class="btn btn-default btn-sm">
                <i class="oi oi-arrow-thick-left"></i>
                Back
            </button>
        </a>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "UserCreate",
    props: {
        client: {type: String, required: true}
    },
    data() {
        return {
            errors: '',
            address: JSON.parse(this.client).addresses,
            user: {}
        }
    },
    methods: {
        addUser() {
            let uri = '/users';
            this.user.clientId = JSON.parse(this.client).id;
            axios.post(uri, this.user).then((response) => {
                window.location.href = `/clients/${JSON.parse(this.client).id}/edit`;
            }).catch(e => {
                this.errors = e.response.data.errors
            })
        },
    },
}

</script>
